<template>
  <!-- DESKTOP TABLE ITEM -->
  <tr
    class="group relative align-top hover:bg-blue-100"
    :class="{ 'bg-blue-10': index % 2 === 0 }"
  >
    <td class="py-4 pl-4 pr-16">
      <h2 class="max-w-text whitespace-pre-wrap" v-html="data.title" />
    </td>

    <td class="py-4 pr-16">
      <p>
        {{ data.author }}
      </p>
    </td>

    <td class="py-4 pr-16">
      <p>{{ data.year }}</p>
    </td>

    <td class="py-4 pr-16">
      <p class="xl:whitespace-nowrap">
        {{ data.issn_isbn }}
      </p>
    </td>

    <td class="py-4 pr-16 text-sm">
      <p>
        <template v-for="(language, i) in data.languages" :key="language">
          {{ language }}{{ i < data.languages.length - 1 ? ',&nbsp;' : '' }}
        </template>
      </p>
    </td>

    <td class="py-4 pr-4 align-top">
      <!-- DOWNLOAD BUTTON -->

      <DownloadButton
        :loading="isLoading"
        :aria-label="`${$t('accessibility.download_document')}: ${data.title}`"
        class="-mt-1 h-6 w-6 p-1 text-blue-800 hover:text-blue-dark"
        @click="downloadFile"
      />
    </td>
  </tr>
</template>

<script setup>
const props = defineProps({
  index: { type: Number, default: null },
  data: { type: Object, default: null },
})

// VARIABLES
const isLoading = ref(false)

// FUNCTIONS

function downloadFile() {
  isLoading.value = true
  fetch(props.data.url)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob)
      const sanitizedTitle = sanitizeFilename(props.data.title)
      const a = document.createElement('a')
      a.href = url
      a.download = `${sanitizedTitle}.pdf`
      document.body.appendChild(a)
      a.click()
      a.remove()
      isLoading.value = false
    })
}
function sanitizeFilename(title) {
  return title.replace(/[/\\?%*:|"<>]/g, '')
}
</script>
